import './bootstrap';

$(function() {

    $('#copyLeftNELink').on('click', function(e) {
        e.preventDefault();
        const options = {
            html: true,
            placement: 'top',
            trigger: 'manual',
            delay: {"show": 0, "hide": 100}
            //content: '<div class="text-center"><i class="fas fa-check-circle fa-2x"></i></div>',
            //delay: { "show": 100, "hide": 100 },
            //template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>'
        }
        const _url = $(this).attr('href').replace('#','');
        navigator.clipboard.writeText(_url);
        const elem = $(this).get(0);
        const tooltip = new bootstrap.Tooltip(elem, options);
        tooltip.toggle();
        setTimeout(function(){
            tooltip.hide();
        }, 500);
        return false;
    });

    $('#copyRightNELink').on('click', function(e) {
        e.preventDefault();
        const options = {
            placement: 'bottom',
            trigger: 'manual',
            delay: {"show": 0, "hide": 100}
        }
        const _url = $(this).attr('href').replace('#','');
        navigator.clipboard.writeText(_url);
        const elem = $(this).get(0);
        const tooltip = new bootstrap.Tooltip(elem, options);
        tooltip.toggle();
        setTimeout(function(){
            tooltip.hide();
        }, 500);
        return false;
    });

    $('#copyLink').on('click', function(e) {
        e.preventDefault();
        const options = {
            placement: 'bottom',
            trigger: 'manual',
            delay: {"show": 0, "hide": 100}
        }
        const _url = $(this).attr('href').replace('#','');
        navigator.clipboard.writeText(_url);
        const elem = $(this).get(0);
        const tooltip = new bootstrap.Tooltip(elem, options);
        tooltip.toggle();
        setTimeout(function(){
            tooltip.hide();
        }, 500);
        return false;
    });

    $('.password-show i').on('click', function () {
        $(this).toggleClass('fa-eye').toggleClass('fa-eye-slash');
        $(this).parent().find('input').each(function (inx, ele) {
            $(ele).attr('type', $(ele).attr('type') === 'password' ? 'text' : 'password');
        });
    });
    //===========================================================================
    /*
    var $sliderIsInitialized = false;
    var $cropper = null;
    var $modal = document.getElementById('profileImageModal');
    if($modal !== null) {
        var $modalObj = new bootstrap.Modal($modal, {backdrop: false});
        $modal.addEventListener('show.bs.modal', function(e) {
            $cropper = new Cropper($newProfileImage, {
                aspectRatio: 1,
                viewMode: 3,
                autoCropArea: 0.5,
                dragMode: 'move',
                preview: '.profile_image_preview',
                ready: function() {
                    $cropper.zoomTo(0);
                    let imageData = $cropper.getImageData();
                    var minSliderZoom = imageData.width / imageData.naturalWidth;
                    $("#zoom-slider").prop('min', minSliderZoom);
                    $("#zoom-slider").prop('value', minSliderZoom);
                }
            });
        });
        $modal.addEventListener('hidden.bs.modal', function(e) {
            if($cropper) {
                $cropper.destroy();
                $cropper = null;
                $sliderIsInitialized = false;
            }
        });
    }
    var $newProfileImage = document.getElementById('newProfileImage');
    var doneLoading = function(url) {
        $newProfileImage.src = url;
        $sliderIsInitialized = true;
        $modalObj.show();
    };
    $("#zoom-slider").on('input', function (event) {
        if ($sliderIsInitialized == true) {
            //if ($cropper.canvasData.naturalWidth < 400 || $cropper.canvasData.naturalHeight < 300) {
            //    event.preventDefault();
            //} else {
                //var currentValue = event.target.value; //$("#zoom-slider").val();
                var currentValue = $("#zoom-slider").val();
                var zoomValue = parseFloat(currentValue);
                $cropper.zoomTo(zoomValue.toFixed(4));
            //}
        }
    });
    $('#file_profile_image').on('change', function(e) {
        let file = e.target.files;
        if(file && file.length > 0) {
            file = file[0];
            if(URL) {
                doneLoading(URL.createObjectURL(file));
            } else if(FileReader) {
                let reader = FileReader();
                reader.onload = function(e) {
                    doneLoading(reader.result);
                }
                reader.readAsDataURL(file);
            }
        }
    });

    $('#changeProfile').on('click', function() {
        $('#file_profile_image').trigger('click');
    });

    $('#btnUpdateProfileImage').on('click', function() {
        let canvas = $cropper.getCroppedCanvas({
            width: 200,
            height: 200,
        });
        $('#loading').removeClass('d-none').css('display', 'flex');
        canvas.toBlob(function(blob) {
            let _formData = new FormData();
            _formData.append('avatar', blob, 'avatar.png');
            _formData.append('_token', $('meta[name="csrf-token"]').attr('content'));
            let _url = URL.createObjectURL(blob);
            //let reader = new FileReader();
            //reader.readAsDataURL(blob);
            //reader.onloadend = function() {
                //var base64data = reader.result;
                $.ajax({
                    url: $baseUrl + "/newera/profile/upload-picture",
                    type: "POST",
                    data: _formData,
                    processData: false,
                    contentType: false,
                    //enctype: 'multipart/form-data',
                    //headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                    success: function(data) {
                        //console.log(data);
                        if(data.status != undefined && data.status === 'ok') {
                            top.location.reload();
                            //document.querySelector('.profile_image').src = _url;
                        }
                    }
                }).done(function() {
                    //
                }).fail(function() {
                    $('#loading').addClass('d-none').css('display', 'none');
                    alert("Unable to upload profile image, please try again.");
                    $modalObj.hide();
                });
            //}
        }, 'image/png');
    });
    */
    //===========================================================================
    $(".form-control").on('input', function () {
        $(this).parent().addClass("focus");
    });
});
//===========================================================================
window.updateActivationCountdown = function (target_timezone_offset, target_hour, timeof_hours, dv_name, dv_name2 = null)
{
    const now = new Date();
    const targetOffset = target_timezone_offset * 3600 * 1000; // Dubai is UTC+4
    const localOffset = now.getTimezoneOffset() * 60000;
    const targetTime1 = new Date(now.getTime() + localOffset + targetOffset);
    const targetTime = new Date(targetTime1);
    targetTime.setHours(target_hour, 0, 0, 0);
    if (now.getTime() > targetTime.getTime() - localOffset - targetOffset + (timeof_hours * 3600 * 1000)) {
        // If current time is past the target time, set for next day
        targetTime.setDate(targetTime.getDate() + 1);
    }
    const localTarget = new Date(targetTime.getTime() - localOffset - targetOffset);
    const diff = Math.floor((localTarget - now) / 1000);
    //console.log(diff);
    if (diff <= 0) {
        $('#'+dv_name).text("00:00:00");
        return false;
    }
    // Calculate hours, minutes, seconds
    const hours = Math.floor(diff / 3600);
    const minutes = Math.floor((diff % 3600) / 60);
    const seconds = diff % 60;
    // Format and display
    const display = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    $('#'+dv_name).text(display);
    if (dv_name2) {
        // Update current Dubai time display
        const targetHours = targetTime.getHours().toString().padStart(2, '0');
        const targetMinutes = targetTime.getMinutes().toString().padStart(2, '0');
        const targetSeconds = targetTime.getSeconds().toString().padStart(2, '0');
        $('#'+dv_name2).text(`${targetHours}:${targetMinutes}:${targetSeconds}`);
    }
    return true;
}
